export default "__VITE_ASSET__DfN$Ca5d__"